<template>
  <div class="content">
    <el-row>
      <el-col :span="22">
        <el-form class="search-form" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="内容">
            <el-input
              v-model="search.content"
              clearable
              maxlength="30"
              placeholder="请输入内容"
            />
          </el-form-item>

          <el-form-item label="一级分类">
            <el-select
              v-model="search.head_pid"
              clearable
              placeholder="请选择一级分类"
            >
              <el-option
                v-for="item in options.headOne"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
              v-model="search.status"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in options.status"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-card">
      <el-button type="primary" size="mini" @click="goAdd">新增模板</el-button>

      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="一级分类" prop="pid_head_text" width="250" />
            <ElTableColumn label="二级分类" prop="child_head_text" />
            <ElTableColumn label="内容" width="260">
              <template slot-scope="{ row }">
                <span class="text-click" @click="changeContent(row)">{{ row.content }}</span>
              </template>
            </ElTableColumn>

            <ElTableColumn label="是否显示复选框" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.is_show_checkbox"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>

            <ElTableColumn label="是否可输入" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.is_show_input"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>

            <ElTableColumn label="状态" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>

            <ElTableColumn label="添加时间" prop="create_time" />
            <ElTableColumn label="添加人" prop="operator_name" />
          </el-table>

          <pagination
            class="page tc mt15"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <!-- 模板调整 -->
    <el-dialog title="模板调整" :visible.sync="changeContentPop" width="40%">
      <el-form
        :inline="true"
        ref="changeData"
        size="mini"
        :model="changeData"
        label-width="150px"
      >
        <el-form-item label="模板内容" prop="content">
          <el-input type="textarea" class="w300" :rows="4" v-model="changeData.content"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="changeContentPop = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitFormC('changeData')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增模板 -->
    <el-dialog title="新增模板" :visible.sync="addSettingPop" width="40%">
      <el-form
        :inline="true"
        ref="verifyDetail"
        size="mini"
        :model="verifyDetail"
        label-width="150px"
      >
        <el-form-item label="一级分类" class="full-row">
          <el-select
            v-model="verifyDetail.first_level_head"
            placeholder="请选择"
            class="w300"
            @change="changeHead"
          >
            <el-option
              v-for="item in options.headOne"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="二级分类" class="full-row">
          <el-select
            v-model="verifyDetail.second_level_head"
            placeholder="请选择"
            class="w300"
          >
            <el-option
              v-for="item in options.headTwo"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="内容" class="full-row">
          <el-input type="textarea" class="w300" :rows="4" v-model="verifyDetail.content"></el-input>
        </el-form-item>

        <el-form-item label="是否显示复选框" class="full-row">
          <el-radio-group v-model="verifyDetail.is_show_checkbox">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否可输入" class="full-row">
          <el-radio-group v-model="verifyDetail.is_show_input">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addSettingPop = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('verifyDetail')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination'
import { goodsList,deleteGoods,exportGoods,categoryList,claimGoods,updateGoods} from '@/api/goods';
import { caseSettingList,upCaseSetting,getHeadCategory,addCaseSetting} from '@/api/case';

class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Search {
  content = '';
  head_pid = '';
  status = 2;
}
class ChangeData{
  id = 0;
  content = '';
}
class VerifyDetail{
  first_level_head = 1;
  second_level_head = '';
  content = '';
  is_show_checkbox = 0;
  is_show_input = 0;
}
class Options {
  headOne = [];
  headTwo = [];
  status = [
    { id: 0, name: "禁用" },
    { id: 1, name: "启用" },
    { id: 2, name: "全部" },
  ];
}

export default {
  name: 'GoodsList',
  components: { pagination },
  data () {
    return {
      verifyDetail: new VerifyDetail(),
      search: new Search(),
      options: new Options(),
      page: new Page(),
      changeData: new ChangeData(),
      list: [],
      idList: [],
      changeContentPop: false,
      addSettingPop:false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted () {
    this.getOptions()
    this.getList()
  },
  methods: {
    handleStatusChange(row){
      upCaseSetting({
        id:row.id,
        status:row.status,
        is_show_checkbox:row.is_show_checkbox,
        is_show_input:row.is_show_input
      }).then(res => {
        this.$message.success(res.msg);
        this.getList()
      }).catch(err => {
        console.error(err);
        this.getList()
      })
    },
    getOptions(){
      getHeadCategory({page:1,limit:10000}).then(res => {
        this.options.headOne = res.data;
      })
    },
    goAdd () {
      this.addSettingPop = true;
      this.getOptions();
      this.verifyDetail = new VerifyDetail();
      this.verifyDetail.is_show_checkbox = 1;
      this.verifyDetail.is_show_input = 1;
    },
    changeContent(row){
      this.changeContentPop = true;
      this.changeData.content = row.content;
      this.changeData.id = row.id;
    },
    changeHead(){
      this.options.headTwo = [];
      this.verifyDetail.second_level_head = '';
      getHeadCategory({page:1,limit:10000,id:this.verifyDetail.first_level_head}).then(res => {
        this.options.headTwo = res.data;
      })
    },
    getList (option) {
      if (option === 'search') this.page = new Page();
      caseSettingList({...this.search,...this.page}).then(res => {
        this.list = res.list;
        this.page.total = res.dataCount;
      })
    },
    tapBtn (type,id) {
      switch (type) {
        case 'detail':
          this.$router.push('./goodsDetail?id=' + id)
          break
        case 'update':
          this.$router.push('./addGoods?id=' + id)
          break
        case 'del':
          this.hint(type,'删除',id)
          break
        case 'export':
          this.hint(type,'导出选中')
          break
        case 'claim':
          this.hint(type,'认领',id)
          break
      }
    },
    hint(type, text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (type == "add") {
          this.confirm();
        } else if(type == "change"){
          this.changeTempFunction();
        } else {
          this.nullify(type);
        }
      }).catch(() => {
        this.$message.info("已取消");
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) this.hint("add", "添加病例模板");
      });
    },
    submitFormC(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) this.hint("change", "调整此模板");
      });
    },
    confirm() {
      addCaseSetting({...this.verifyDetail}).then(res => {
        this.$message.success(res.msg);
        this.addSettingPop = false;
        this.getList();
      });
    },
    changeTempFunction() {
      upCaseSetting({...this.changeData}).then(res => {
        this.$message.success(res.msg);
        this.changeContentPop = false;
        this.getList();
      });
    },
    claimGoods(id){
      claimGoods({goods_id:id}).then(res => {
        this.$message.success(res.msg);
        this.getList()
      })
    },
    getExport(){
      exportGoods({...this.search}).then(res => {
        window.open(res.data.url);
      })
    },
    handleSelectionChange (val) {
      this.idList = val.map(i => i.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  min-height: 100vh;
}

/* 搜索卡片 */
.search-card {
  background: #fff;
  border-radius: 6px;
  padding: 14px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.full-row {
  display: block;
  width: 100%;
}

.search-form .el-form-item {
  margin-right: 24px;
  margin-bottom: 8px;
}

/* 表格卡片 */
.table-card {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.table-card .el-button {
  margin-bottom: 15px;
}

/* 表格内容居中 */
:deep(.el-table__cell) {
  padding: 10px 0;
  text-align: center;
}

/* 可点击文字 */
.text-click {
  color: #1890ff;
  cursor: pointer;
}

/* 分页 */
.page {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

/* 弹窗 */
:deep(.el-dialog) {
  border-radius: 6px;
  .el-form-item {
    margin-right: 0;
    margin-bottom: 15px;
  }
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

.w220 {
  width: 220px !important;
}
</style>